module.exports = __webpack_public_path__ + "img/slzc.4f59635a.jpg";